export const ScrubTools = {
    maskEmail: (s: string) => {
        const emailRegex = /([\w.-]+)@(([\w.-]+\.)+\w+)/gi;
        let match = emailRegex.exec(s);
        while (match) {
            s = s.replace(match[0], `${ScrubTools.getHashString(match[1])}@${ScrubTools.getHashString(match[2])}.MASKED`);
            match = emailRegex.exec(s);
        }

        return s;
    },


    getHashString: (s: string): string => {
        return ScrubTools.getHashCode(s).toString(16);
    },


    getHashCode: (s: string): number => {
        let hash = 0;
        if (!s) {
            return hash;
        }
        for (let i = 0; i < s.length; ++i) {
            hash = ((hash << 5) - hash) + s.charCodeAt(i);
            hash |= 0; // to int32
        }

        return hash;
    }
}
